import {SearchInputStatus, VisibleStatus} from "./utils/consts";
import {createEvent} from "./utils/common";

export const responsibleSearch = () => {
  const responsibleSearchElement = document.querySelector(`.js-responsible-search`);

  if (responsibleSearchElement) {
    const changeResponsibleTypeElement = responsibleSearchElement.querySelector(`.js-responsible-radio-type`);
    const searchInputElement = responsibleSearchElement.querySelector(`.js-responsible-search-input`);
    const hiddenInputElement = responsibleSearchElement.querySelector(`.js-task-search-h-input`);
    const searchResultModal = responsibleSearchElement.querySelector(`.js-task-search-modal`);
    const searchResultList = searchResultModal.querySelector(`.js-task-search-list`);
    const createTaskForm = changeResponsibleTypeElement.form;
    const changeResponsibleName = changeResponsibleTypeElement.name;
    const responsibleValue = changeResponsibleTypeElement.value;

    const setModalVisibleStatus = (status) => {
      switch (status) {
        case VisibleStatus.SHOW:
          searchResultModal.dispatchEvent(createEvent(`openSelect`));
          break;
        case VisibleStatus.HIDE:
          searchResultModal.dispatchEvent(createEvent(`closeSelect`));
          break;
      }
    };

    const activateSearchInput = (status) => {
      switch (status) {
        case SearchInputStatus.ACTIVATE:
          setModalVisibleStatus(VisibleStatus.SHOW);
          break;
        case SearchInputStatus.DISABLED:
          setModalVisibleStatus(VisibleStatus.HIDE);
          setCurrentValue();
          break;
      }
    };

    const filterItems = (value) => {
      searchResultList.querySelectorAll(`.js-select-item`).forEach((item) => {
        const nameElement = item.querySelector(`.js-search-responsible-name`);

        if (nameElement) {
          const name = nameElement.textContent.trim().toLowerCase();

          if (!value.length) {
            item.classList.remove(`modal__item--hide`);
            return;
          }

          if (name.includes(value.trim().toLowerCase())) {
            item.classList.remove(`modal__item--hide`);
          } else {
            item.classList.add(`modal__item--hide`);
          }
        }
      });
    };

    const hideTitles = () => {
      searchResultList.querySelectorAll(`.modal__list`).forEach((list) => {
        if (Array.from(list.children).every((item) => item.classList.contains(`modal__item--hide`))) {
          list.previousElementSibling.style.display = "none";
        } else {
          list.previousElementSibling.style.display = null;
        }
      });
    };

    const setCurrentValue = () => {
      const currentElement = Array.from(searchResultList.querySelectorAll(`.js-select-item`)).find((element) =>
        element.classList.contains(`modal__item--active`),
      );
      currentElement && currentElement.classList.remove(`modal__item--active`);

      const newElement = Array.from(searchResultList.querySelectorAll(`.js-select-item`)).find(
        (element) => element.dataset.value === createTaskForm[changeResponsibleName].value,
      );

      hiddenInputElement.value = createTaskForm[changeResponsibleName].value;
      newElement.classList.add(`modal__item--active`);
      newElement.dispatchEvent(createEvent(`setItem`));
    };

    const onSearchFieldInput = (evt) => {
      try {
        const self = evt.currentTarget;
        filterItems(self.value);
        hideTitles();
      } catch (e) {
        if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
          window.sendError.sendMessage(e);
        }

        console.error(e);
      }
    };

    const onCreateTaskFormChange = (evt) => {
      const target = evt.target;

      if (target.tagName === `INPUT` && target.name === `responsible`) {
        if (createTaskForm[changeResponsibleName].value === responsibleValue) {
          activateSearchInput(SearchInputStatus.DISABLED);
        } else if (createTaskForm[changeResponsibleName].value === `another`) {
          activateSearchInput(SearchInputStatus.ACTIVATE);
        }
      }
    };

    const onHiddenInputChange = () => {
      if (hiddenInputElement.value === responsibleValue) {
        createTaskForm[changeResponsibleName].value = responsibleValue;
      } else {
        createTaskForm[changeResponsibleName].value = `another`;
      }
    };

    createTaskForm.addEventListener(`change`, onCreateTaskFormChange);
    searchInputElement.addEventListener(`input`, onSearchFieldInput);
    hiddenInputElement.addEventListener(`change`, onHiddenInputChange);
  }
};
